import { useEffect } from 'react'
import { useState }  from 'react'
import { animate }   from 'framer-motion'
import { getFocus, useGet } from 'state/jotai'
import { getIsoData } from 'state/jotai.isometryDataHooks'
import { _seasons_isometry } from 'state/store.season'
import { active_project, seasonMode } from 'state/store.global'

export const Play = ({frame, setFrame, config }) => {

  const min = config.FIRST_IMAGE
  const max = config.LAST_IMAGE
  const num = config.IMAGE_NUM


  const [state, setState]     = useState()
  // const [playing, setPlaying] = useState(true)

  const [from, setFrom] = useState(frame)
  const [to, setTo]     = useState(max+(frame-min))

  const { pin, pid }        = useGet(active_project);
  const season              = getFocus(_seasons_isometry, 'season_type');
  const activeIsometryFrame = getIsoData("activeframe");
  const seasonType          = season?.[pin]?.[pid]?.[activeIsometryFrame]?.type;
  const isSeasonModeOn = useGet(seasonMode);
  
  useEffect(()=>{
    const controls = animate(from, to, {
      duration   : isSeasonModeOn ? 50 : pin > 0 ? 3.2 : 4.5,
      ease       : 'linear',
      repeat     : Infinity,
      onUpdate   : v => {
        const val = Number(v.toFixed(0))
        const to = ( val > max ) ? val - num + 1 : val 
        setFrame(to)
      } 
    })
    return () => {
      controls.stop()
    }
  },[from,to,isSeasonModeOn])

  return null
}